import { type ReactNode } from 'react';
import { type LinkProps, Link } from 'react-router-dom';

export const wrapInOptionalLink = (template: ReactNode, url?: string, props?: { key?: string | number; } & Omit<LinkProps, 'to'>) => {
    if (!url) return <div {...props as any}>{template}</div>;
    else return <Link to={url} {...props}>{template}</Link>;
};